import React, { useState, useEffect } from 'react';
import { Award, Briefcase, Users } from 'lucide-react';
import { useInView } from 'react-intersection-observer';

const AboutInstructor = () => {
  const instructorImage = "https://static-media.hotmart.com/bA9jLWmkRQu7lOmYuDWTlfh9riA=/filters:quality(100):format(webp)/klickart-prod/uploads/media/file/8242028/dani-whats.jpeg";
  
  const [projectsCount, setProjectsCount] = useState(0);
  const [devsCount, setDevsCount] = useState(0);
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true
  });

  useEffect(() => {
    if (inView) {
      const projectsDuration = 2000; // 2 seconds
      const projectsIncrement = 200 / (projectsDuration / 16); // 60 FPS
      
      const devsDuration = 2000;
      const devsIncrement = 5000 / (devsDuration / 16);
      
      const projectsInterval = setInterval(() => {
        setProjectsCount(prev => {
          if (prev < 200) {
            return Math.min(prev + projectsIncrement, 200);
          }
          clearInterval(projectsInterval);
          return 200;
        });
      }, 16);
      
      const devsInterval = setInterval(() => {
        setDevsCount(prev => {
          if (prev < 5000) {
            return Math.min(prev + devsIncrement, 5000);
          }
          clearInterval(devsInterval);
          return 5000;
        });
      }, 16);

      return () => {
        clearInterval(projectsInterval);
        clearInterval(devsInterval);
      };
    }
  }, [inView]);

  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
          Quem irá te conduzir na <span className="border-b-4 border-[#f2055c]">Java Dev Week</span>
        </h2>

        <div className="flex flex-col md:flex-row gap-12 items-center">
          <div className="w-full md:w-2/5">
            <div className="relative">
              <div className="w-64 h-64 md:w-80 md:h-80 mx-auto overflow-hidden rounded-full border-4 border-[#f2055c] shadow-xl">
                <img 
                  src={instructorImage} 
                  alt="Daiane, Java Instructor" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 right-0 md:right-12 bg-[#f2055c] text-white px-6 py-3 rounded-full shadow-lg">
                <span className="font-bold">Java Expert</span>
              </div>
            </div>
          </div>

          <div className="w-full md:w-3/5 animate-fadeInRight">
            <h3 className="text-2xl font-bold mb-4">Daniele Leão</h3>
            <h4 className="text-xl font-bold text-[#f2055c] mb-4">
              Mais de 17 anos de estrada em Java.<br />
              Agora, ela está te esperando na linha de chegada.
            </h4>
            <p className="text-gray-700 mb-6 text-lg">
              Especialista em desenvolvimento Java há quase duas décadas, com experiência em grandes projetos nacionais e internacionais. Agora, eu quero te mostrar o caminho do início ao reconhecimento.
            </p>

            <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
              <div className="flex flex-col items-center bg-white p-4 rounded-lg shadow-sm">
                <Briefcase className="w-10 h-10 text-[#f2055c] mb-2" />
                <span className="text-3xl font-bold">+{Math.round(projectsCount)}</span>
                <span className="text-gray-600 text-sm text-center">Projetos Entregues</span>
              </div>

              <div className="flex flex-col items-center bg-white p-4 rounded-lg shadow-sm">
                <Users className="w-10 h-10 text-[#f2055c] mb-2" />
                <span className="text-3xl font-bold">+{Math.round(devsCount)}</span>
                <span className="text-gray-600 text-sm text-center">Alunos</span>
              </div>

              <div className="flex flex-col items-center bg-white p-4 rounded-lg shadow-sm">
                <Award className="w-10 h-10 text-[#f2055c] mb-2" />
                <span className="text-2xl font-bold">Top Voice</span>
                <span className="text-gray-600 text-sm text-center">No LinkedIn</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutInstructor;